import React from 'react'
import {SupplierUser} from '../core/_models'

interface UserInfoCellProps {
  user: SupplierUser
}

const UserInfoCell: React.FC<UserInfoCellProps> = ({user}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='symbol symbol-45px me-5'>
        <div className='symbol-label fs-3 bg-light-primary text-primary'>
          {user.name.charAt(0).toUpperCase()}
        </div>
      </div>
      <div className='d-flex justify-content-start flex-column'>
        <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
          {user.name}
        </a>
        <span className='text-muted fw-bold text-muted d-block fs-7'>
          {user.email}
        </span>
      </div>
    </div>
  )
}

export {UserInfoCell}
